<template lang="pug">
.crud
  modal-add-attachment(:is-add='isModalAdd' :sale_id='sale_id')
  vm-row(vm-w="12" vm-type="flex" vm-justify="space-between" class="information__wrapper")
    vm-col.card(vm-sm=12)
      .flex-wrap
        button-line-dot(text=" agregar adjunto" @click="addAttachment")
        file-download-card(:model="sale.quotation" modelText='quotations')
        file-download-card(:key="index" v-for="(item, index) in sale.purchase_orders" :model="item" modelText='purchase-orders')
        file-download-card(:model="sale" v-if='sale.sendings.lenght > 0' modelText='packing_list')
        file-card(:key="index" v-for="(item, index) in registry" :data="item" :showDelete="true" :showSee="false" @view="openViewer(registry[index])" @delete="deleteAttachmentConfirm")
    vm-col.card(vm-sm=12)
      vm-row(vm-align="left" vm-type="flex" vm-justify="left" vm-w="12")
        h3.purchase__order_title Seguimiento
        vm-col.bottom_margin(vm-sm=12)
          vm-table(max-height="500px" :data="sale.tracings")
            template(slot="header")
              .d-flex.justify-content-between
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columnsTracing") {{ $t('sale_tracings.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columnsTracing")
                  .row
                    slot(v-if="column == 'text'") {{ data[indextr][column] }}
                    slot(v-if="column == 'created_at'") {{ data[indextr][column] | moment('DD-MMMM-YYYY') }}
                    vm-chip(v-if="column == 'status'" :color="colorStatus(data[indextr][column])") {{data[indextr]['status_display']}}
                vm-td(v-if="data[indextr]['status'] != '2'")
                  vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                    vm-dropdown-menu
                      vm-dropdown-item.d-flex.justify-content-between(@click="acctionAttended(data[indextr])")
                        vm-icon(icon="checkmark-outline")
                        slot &nbsp;{{ $t('strings.attended') }}
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Sales')

export default {
  name: 'SaleRegistry',
  components: {
    FileCard: () => import('@/components/additionals/FileCard.vue'),
    FileDownloadCard: () => import('@/components/additionals/FileDownloadCard.vue'),
    ButtonLineDot: () => import('@/components/additionals/ButtonLineDot.vue'),
    ModalAddAttachment: () => import('@/components/modals/ModalAddAttachment.vue')
  },
  props: {
    sale: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    sale_id: null,
    columnsTracing: [
      'text',
      'created_at',
      'status'
    ],
    status: [
      {
        text: 'Pendiente',
        value: 1,
        color: 'warning'
      },
      {
        text: 'Atendido',
        value: 2,
        color: 'primary'
      }
    ]
  }),
  computed: {
    ...mapGetters(['sale', 'registry'])
  },
  watch: {
  },
  async created () {
    await this.loadSaleInformation({ sale_id: this.$route.params.id }).then(() => {
      this.loadSaleRegistry({ sale_id: this.sale.id })
    })
  },
  methods: {
    ...mapActions([
      'loadSaleInformation',
      'loadSaleRegistry',
      'setModalAttachmentVisible',
      'deleteAttachment',
      'setAttended'
    ]),
    openViewer (record) {
      window.open(record.attachment_doc, '_blank')
    },
    addAttachment () {
      this.isModalAdd = true
      this.setModalAttachmentVisible(true)
      this.newRecord = {}
      this.sale_id = parseInt(this.$route.params.id)
    },
    deleteAttachmentConfirm (attachment) {
      let t = this
      this.auxDeleteAttachment = () => {
        t.deleteAttachment(attachment).then(() => {
          t.loadSaleRegistry({ sale_id: this.sale.id })
        })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation2', { model: this.$t('strings.attachment'), attribute: attachment.attachment }),
        accept: this.auxDeleteAttachment
      })
    },
    colorStatus (code) {
      return this.status.find(e => e.value === parseInt(code)).color
    },
    acctionAttended (tracing) {
      this.setAttended(tracing.id)
    }
  }
}
</script>

<style lang="scss" scoped>
  .gallery-container {
    padding: 20px 15px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr) );
    grid-gap: 15px;
  }
.information__wrapper {
  margin-top: 25px;
  .card {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px !important;
    height: 100% !important;
    .card-body {
      padding: 10px !important;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .icon__wrapper {
        padding: 10px !important;
        border-radius: 0.5em;
        background-color: #dfdfdf;
      }
    }
  }
}

.purchase__order_title {
  font-weight: bold;
}

.text__helper {
  font-size: 16px;
  text-align: center;
}

.list__wrapper_supplier,
.list__wrapper_purchase {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 25px;
  padding-left: 0 !important;
  .list__item__wrapper {
    width: 100%;
    padding-left: 0 !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #94949493;
    .radio__button {
      padding: 10px;
      cursor: pointer;
    }
    .text__purchase {
      padding: 10px;
      font-size: 20px;
      font-weight: bold;
      cursor: pointer;
    }
    .status__display {
      font-size: 12px;
      border-radius: 0.5em;
      box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.2);
      padding: 5px 10px;
      color: #fff;
      cursor: pointer;
    }
  }
}

.text__supplier {
  color: #026481;
  font-weight: bold;
}

.table {
  padding-left: 0 !important;
  .vm-table-text {
    padding-left: 0 !important;
  }
}
/* Helpers */
.gutters {
  padding: 20px;
}
.h-100 {
  height: 100%;
}

.p-0 {
  padding: 0 !important;
}

.input__wrapper,
.actions__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bottom_margin {
  margin-bottom: 40px;
}
.flex-wrap {
  display: flex;
  flex-wrap: wrap;
}
</style>
